<template>
    <div class="coupon_course">

        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :immediate-check="false"
                @load="getCouponCourse"
                class="content-collect"
        >
        <div class="course-li">
            <div class="time-table-title" v-for="(item,index) in list" :key="index" @click="bindGoCurriculum(item.course_id)">
                <div class="table-title-text">
                    <div class="title-text">
                        {{item.name}}
                    </div>
                    <div class="title-text-appointment">
                        <span class="iconfont iconchakan"></span> {{item.study_count || 0}} 次观看
                        <span class="text-appointment-type">
                            <span v-if="(item.money*1) >0">￥ {{item.money*1}}</span>
                            <span v-else>免费</span>
                        </span>
                    </div>
                </div>
                <div class="table-title-img">
                    <img class="title-img" :src="item.cover"/>
                </div>
            </div>
        </div>
        </van-list>
    </div>
</template>

<script>
    import { List } from 'vant';
    export default {
        name: "coupon_course",
        components:{
            [List.name]:List
        },
        data(){
            return {
                coupon_id:'',
                list:[],
                total:0,
                page:1,
                pageSize:10,
                loading: false,
                finished: false,
            }
        },
        mounted() {
            this.coupon_id = this.util.getQueryStr('coupon_id');
            this.getCouponCourse(1);
            this.bindWeiXin();
        },
        methods:{
            bindWeiXin(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    _self.util.wxShare(wx, {
                        title: '课程优惠券',
                        desc: '课程优惠券',
                        link: location.href,
                        imgUrl: this.util.G_CONFIG.logo
                    });
                });
            },
            getCouponCourse(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{

                    this.page=page;

                }

                this.util.server.mini_coupon.coupon_course({
                    data:{
                        coupon_id:this.coupon_id,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                // for (var i = 0; i < data.items.length; i++) {
                                //     data.items[i]['link'] = this.util.getMiniCourseTypeUrl(data.items[i].type, data.items[i].course_id, data.items[i].p_course_id) + '&current=' + (data.items[i].sections_id || '');
                                // }

                                if(page == 1){
                                    this.list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;
                                //判断是否存在下一页
                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            bindGoCurriculum(course_id){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+course_id+'&token='+this.util.token)
            },
        }
    }
</script>

<style scoped>
    .time-table-title{
        position: relative;
        margin: 10px;
        height:100px;
    }
    .table-title-text{
        padding-left: 150px;
        height: 100px;
    }
    .title-text{
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 32px;
    }
    .title-text-appointment{
        font-size: 12px;
        position: relative;
        margin-top: 50px;
    }
    .text-appointment-type{
        position: absolute;
        right: 0;
        color: #f30;
    }
    .title-text-appointment .iconfont{
        font-size: 12px;
    }
    .table-title-img{
        position: absolute;
        left: 0;
        top: 0;
        font-size: 0;
        height: 100px;
    }
    .title-img{
        width: 145px;
        height: 100%;
    }
</style>
